import { Skeleton } from "@mui/material";

function SkeletonInstance({ variant, animation, width, height, sx }) {
    return (
        <Skeleton variant={variant} animation={animation} width={width} height={height} sx={sx} />
    )
}
export default SkeletonInstance;